
import Globals from './Globals.js';
import Instructor from './Instructor.js';
import { $t } from '../service/i18n.js';
import { formatDate } from 'date-fns';

class GroupHours {
  static weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  static fields = [
    '*',
    'instructor.*',
  ];

  constructor(data) {
    Object.assign(this, data);

    
    this.instructor = data.instructor ? new Instructor(data.instructor) : null;
    this.time_formatted = this.timeF;
}

  get durationF() {
    const start = new Date(`1970-01-01T${this.start}:00`);
    const end = new Date(`1970-01-01T${this.end}:00`);
    const duration = new Date(end - start);
    const hours = duration.getUTCHours();
    const minutes = duration.getUTCMinutes();
    return `${hours}h ${minutes}m`;
  }

  get timeF() {
    
    function formatTimeA(timevalue) {
      return timevalue.replace(/(\d{2}):(\d{2}):(\d{2})/, (match, p1, p2, p3) => `${p1}:${p2}`);
    }

    function formatTime(timevalue) {
      // Check if timevalue is in ISO datetime format
      if (timevalue.includes('T')) {
      const date = new Date(timevalue);
      const dateStr = date.toLocaleDateString(Globals.APP_LOCALE || 'pl-PL', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      });
      const timeStr = date.toLocaleTimeString(Globals.APP_LOCALE || 'pl-PL', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
      return `${dateStr}, ${timeStr}`;
      }
      // Handle HH:MM:SS format
      return timevalue.replace(/(\d{2}):(\d{2}):(\d{2})/, (match, p1, p2, p3) => `${p1}:${p2}`);
    }

    if (!this.start || !this.end) return '';
    if (this.start === this.end) return formatTime(this.start);
    if (!this.start.includes(':') || !this.end.includes(':')) return '';
    if (this.start === '00:00:00' && this.end === '23:59:59') {
      return 'Cały dzień';
    }
    if (!this.start) return formatTime(this.end);
    if (!this.end) return formatTime(this.start);
    return `${formatTime(this.start)} - ${formatTime(this.end)}`;
  }
}

export default GroupHours;